var AcceptTypeEnum;
(function (AcceptTypeEnum) {
    AcceptTypeEnum["pdf"] = "application/pdf";
    AcceptTypeEnum["doc"] = "application/msword";
    AcceptTypeEnum["docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    AcceptTypeEnum["xls"] = "application/vnd.ms-excel";
    AcceptTypeEnum["xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    AcceptTypeEnum["ppt"] = "application/vnd.ms-powerpoint";
    AcceptTypeEnum["pptx"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    AcceptTypeEnum["rar"] = "application/vnd.rar";
    AcceptTypeEnum["zip"] = "application/zip";
    AcceptTypeEnum["jpeg"] = "image/jpeg";
    AcceptTypeEnum["gif"] = "image/gif";
    AcceptTypeEnum["png"] = "image/png";
    AcceptTypeEnum["svg"] = "image/svg+xml";
    AcceptTypeEnum["mp3"] = "audio/mpeg";
    AcceptTypeEnum["mpeg"] = "video/mpeg";
    AcceptTypeEnum["avi"] = "video/x-msvideo";
})(AcceptTypeEnum || (AcceptTypeEnum = {}));
var AcceptTypeNameEnum;
(function (AcceptTypeNameEnum) {
    AcceptTypeNameEnum["pdf"] = "pdf";
    AcceptTypeNameEnum["doc"] = "doc";
    AcceptTypeNameEnum["docx"] = "docx";
    AcceptTypeNameEnum["xls"] = "xls";
    AcceptTypeNameEnum["xlsx"] = "xlsx";
    AcceptTypeNameEnum["ppt"] = "ppt";
    AcceptTypeNameEnum["pptx"] = "pptx";
    AcceptTypeNameEnum["rar"] = "rar";
    AcceptTypeNameEnum["zip"] = "zip";
    AcceptTypeNameEnum["jpeg"] = "jpeg";
    AcceptTypeNameEnum["gif"] = "gif";
    AcceptTypeNameEnum["png"] = "png";
    AcceptTypeNameEnum["svg"] = "svg";
    AcceptTypeNameEnum["mp3"] = "mp3";
    AcceptTypeNameEnum["mpeg"] = "mpeg";
    AcceptTypeNameEnum["avi"] = "avi";
})(AcceptTypeNameEnum || (AcceptTypeNameEnum = {}));
export { AcceptTypeEnum, AcceptTypeNameEnum };
//# sourceMappingURL=AcceptTypeEnum.js.map